import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetStatsQuery } from '@platform/state/api';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { openClosedOf } from '@platform/core/lib/recordCounts';
import { routes } from '@platform/core/lib/routes';
import type { IModuleTableRowProps } from './IModuleTableRowProps';

/** Рядок реалізованої таблиці в «Таблицях модуля» (прототип v4): назва (600), «відкрито N» і загальна кількість моноширинним; веде до таблиці. */
export function ModuleTableRow({ ws, moduleKey, rt }: IModuleTableRowProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const { data } = useGetStatsQuery({ ws, rt: rt.key, by: 'status', params: {} });
  const counts = openClosedOf(data, rt.statuses);
  return (
    <Link className="mp-trow" to={routes.list(moduleKey, rt.key, 'table')}>
      <span className="mp-trow__name">{strings.entity(rt.key, 'name', rt.name)}</span>
      <span className="mp-trow__open">{data ? t('modBody.openN', { count: counts.open }) : ''}</span>
      <span className="mp-trow__count">{data ? counts.total : '…'}</span>
    </Link>
  );
}
